import { CHART_TYPES } from '../constants/chartTypes';

const QUERY_MAP = Object.freeze({
  number: { questionType: 'single_number', visualizationMode: 'number' },
  line: { questionType: 'trend', visualizationMode: 'line' },
  bar: { questionType: 'compare', visualizationMode: 'bar' },
  pie: { questionType: 'compare', visualizationMode: 'pie' },
  table: { questionType: 'table', visualizationMode: 'table' },
});

const CONFIG_MAP = Object.freeze({
  number: {
    showGroupBy: false,
    showTrendInfo: false,
    showMeasure: true,
    requiresDimension: false,
    configureHintKey: 'numberConfigureHint',
  },
  line: {
    showGroupBy: false,
    showTrendInfo: true,
    showMeasure: true,
    requiresDimension: false,
    configureHintKey: 'lineConfigureHint',
  },
  bar: {
    showGroupBy: true,
    showTrendInfo: false,
    showMeasure: true,
    requiresDimension: true,
    configureHintKey: 'barConfigureHint',
  },
  pie: {
    showGroupBy: true,
    showTrendInfo: false,
    showMeasure: true,
    requiresDimension: true,
    configureHintKey: 'pieConfigureHint',
  },
  table: {
    showGroupBy: true,
    showTrendInfo: false,
    showMeasure: true,
    requiresDimension: true,
    configureHintKey: 'tableConfigureHint',
  },
});

export function chartTypeToQuery(chartType) {
  return QUERY_MAP[chartType] || QUERY_MAP.bar;
}

export function getChartConfig(chartType) {
  return CONFIG_MAP[chartType] || CONFIG_MAP.bar;
}

export function isValidChartType(chartType) {
  return CHART_TYPES.some((item) => item.id === chartType);
}

export function getChartConfigureHintKey(chartType) {
  return getChartConfig(chartType).configureHintKey || 'barConfigureHint';
}

export function resolvePreviewVisualization(chartType, backendViz) {
  if (chartType === 'pie') return 'pie';
  if (chartType === 'number') return 'number';
  if (chartType === 'table') return 'table';
  if (chartType === 'line') return 'line';
  if (chartType === 'bar') return 'bar';
  return backendViz || 'bar';
}

export function querySpecToChartType(spec = {}) {
  const mode = spec.visualization?.mode;
  if (mode && mode !== 'auto') {
    if (['number', 'line', 'bar', 'pie', 'table'].includes(mode)) return mode;
  }
  const questionType = spec.question_type;
  if (questionType === 'single_number') return 'number';
  if (questionType === 'trend') return 'line';
  if (questionType === 'table') return 'table';
  if (questionType === 'compare') return mode === 'pie' ? 'pie' : 'bar';
  return 'bar';
}
